import { Transformation } from "./Transformation.js";
/**
 * @summary SDK
 * @extends {SDK.Transformation}
 * @memberOf SDK
 */
class ImageTransformation extends Transformation {
}
export { ImageTransformation };
